import React from "react";
import * as Icons from "lucide-react";
import GlassCard from "@/components/common/GlassCard";
import { Button } from "@/components/ui/button";

const TOOLS = [
  {
    to: "/seo/site-files",
    icon: "Map",
    title: "Sitemap, robots & AI files",
    blurb: "Control what Google and AI crawlers are allowed to read (robots, sitemap, llms.txt).",
  },
  {
    to: "/seo/redirects",
    icon: "ArrowRightLeft",
    title: "Redirects",
    blurb: "Send an old URL to a new one (301). Use when you rename or remove a page.",
  },
  {
    to: "/seo/url-health",
    icon: "HeartPulse",
    title: "URL & speed checks",
    blurb: "Canonical/HTTPS consistency and Core Web Vitals (optional speed check).",
  },
  {
    to: "/seo/reports",
    icon: "FileBarChart",
    title: "Export reports",
    blurb: "Download a JSON / CSV / PDF snapshot of site SEO health.",
  },
  {
    to: "/seo/settings",
    icon: "Settings2",
    title: "Settings & Google Search Console",
    blurb: "Site address, crawl schedule, and connect Google for rankings.",
  },
  {
    to: "/seo/labs",
    icon: "FlaskConical",
    title: "Labs (power users)",
    blurb: "Multi-site, A/B title tests, competitor snippets, AI citation log. Optional.",
  },
];

/** Single place for less-common SEO tools so the main nav stays short. */
export default function SEOAdvanced({ onNavigate }) {
  return (
    <div className="space-y-4 w-full max-w-[1600px]">
      <GlassCard className="p-5">
        <h2 className="text-sm font-medium text-white">Advanced SEO tools</h2>
        <p className="text-xs text-white/50 mt-1 leading-relaxed">
          Day-to-day work is on <strong className="text-white/70 font-medium">Start here</strong>, <strong className="text-white/70 font-medium">Pages</strong>, and <strong className="text-white/70 font-medium">Problems</strong>.
          Everything below is optional.
        </p>
      </GlassCard>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {TOOLS.map((t) => {
          const Icon = Icons[t.icon] || Icons.Settings2;
          return (
            <GlassCard key={t.to} className="p-4 flex flex-col sm:flex-row sm:items-start gap-4 h-full">
              <div className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center shrink-0">
                <Icon className="w-5 h-5 text-white/70" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm text-white font-medium">{t.title}</h3>
                <p className="text-xs text-white/50 mt-1 leading-relaxed">{t.blurb}</p>
              </div>
              <Button size="sm" variant="ghost" className="text-cyan-300/90 shrink-0 self-start" onClick={() => onNavigate(t.to)}>
                Open
              </Button>
            </GlassCard>
          );
        })}
      </div>
    </div>
  );
}
